import { render, staticRenderFns } from "./PersonnelTabContentMobile.vue?vue&type=template&id=5f3d1525&"
import script from "./PersonnelTabContentMobile.vue?vue&type=script&lang=js&"
export * from "./PersonnelTabContentMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports